import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { oUser } from 'src/app/modals/user';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //if (req.method=="GET")
    //    return next.handle(req);
    const token = JSON.parse(localStorage.getItem('user'));
    if (!token) {
        return next.handle(req);
    }
    //console.error(req.method=="GET");
    const headers = req.clone({
        headers: req.headers.set('Authorization', token.Token)
    });
    return next.handle(headers);
  }
}